import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("loading-spinner")
export class LoadingSpinner extends LitElement {
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="flex items-center justify-center py-12">
        <div class="w-8 h-8 border-2 border-hb-border border-t-hb-accent rounded-full animate-spin"></div>
      </div>
    `;
  }
}
